// 折线图
export default {
  name: '折线图',
  type: 'line',
  option: (data) => ({
    xAxis: {
      type: 'category',
      axisTick: {
        show: false,
      },
      data: data.x,
    },
    grid: {
      containLabel: true,
      left: 10,
      right: 10,
      top: 30,
      bottom: 20,
    },
    yAxis: {
      type: 'value',
    },
    tooltip: {
      trigger: 'axis',
    },
    series: data.y.map((item) => ({
      type: 'line',
      smooth: true,
      ...item,
    })),
  }),
};
